import { Login as PageLogin } from '@hungryroot/page-login';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const LoginIsland = islandRoot(PageLogin);
